import React from "react";
import Picture from "../common/Picture";
import {MenuData} from "../../config/menuData";
import {MenuIcon} from "../common/Icons";
import {Link} from "react-router-dom";

interface HeaderProps {
    isScrolled: boolean;
    menuData: MenuData;
    onMenuOpen: () => void;
}

export const Header: React.FC<HeaderProps> = ({isScrolled, menuData, onMenuOpen}) => {
    const showStickyLayout = isScrolled;

    return (
        <header
            className={`sticky -mt-16 top-0 left-0 right-0 z-40 transition-all duration-300 ${
                showStickyLayout ? 'bg-ivory shadow-lg' : 'bg-transparent'
            }`}
        >
            <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div
                    className={`flex items-center justify-between h-16 ${
                        showStickyLayout ? 'text-royal-pine' : 'text-ivory'
                    }`}
                >
                    {/* Left Group */}
                    <div className="flex items-center flex-1 lg:flex-none">
                        <Link to="/" className="flex-shrink-0">
                            <Picture
                                pngSrc="/images/logo.png"
                                alt="All Aces Club Logo"
                                className={`h-10 sm:h-12 w-auto cursor-pointer transition-all duration-300 ${
                                    showStickyLayout ? 'block' : 'hidden'
                                }`}
                                loading="lazy"
                                onErrorSrc={'https://placehold.co/150x60/153D40/C6A375?text=All+Aces'}
                            />
                        </Link>

                        {/* Desktop Navigation - Hidden on Mobile */}
                        <div
                            className={`hidden lg:flex items-center space-x-6 xl:space-x-8 transition-all duration-300 ${
                                showStickyLayout ? 'ml-8' : 'ml-0'
                            }`}
                        >
                            {Object.keys(menuData).map(title => {
                                const item = menuData[title];
                                if (item.subLinks.length > 0) {
                                    return (
                                        <button
                                            key={title}
                                            onClick={() => onMenuOpen()}
                                            className="nav-font tracking-wider hover:text-logo-color transition-colors whitespace-nowrap"
                                        >
                                            {title}
                                        </button>
                                    );
                                }
                                return (
                                    <Link
                                        key={title}
                                        to={`/${item.targetId}`}
                                        className="nav-font tracking-wider hover:text-logo-color transition-colors whitespace-nowrap"
                                    >
                                        {title}
                                    </Link>
                                );
                            })}
                        </div>
                    </div>

                    {/* Right Group */}
                    <div className="flex items-center space-x-4">
                        <button onClick={() => onMenuOpen()} className="p-2 -m-2" aria-label="Open Menu">
                            <MenuIcon className="h-6 w-6 sm:h-7 sm:w-7 hover:text-logo-color transition-colors"/>
                        </button>
                    </div>
                </div>
            </nav>
        </header>
    );
};